import { IApplicationState } from '../../types/redux';

export function selectFetchOtpError(state: IApplicationState) {
  return state.otp.fetchOtpError;
}
